import {UserStatistics} from '../entities/users.entity';
import {userActions} from './user.actions';
import {Action, createReducer, on} from '@ngrx/store';
import {StoreReducer} from '../../global/entities/store';

export interface UserState {
  statistics: UserStatistics
}

export const initialState: UserState = {
  statistics: {
    free: null,
    current: null
  }
};

const userReducerFunction = (
  state: UserState | undefined = initialState,
  action: Action
): UserState => {
  const reducer = createReducer(
    initialState,
    on(userActions.clearUserStatistics, (state, _) => ({
      ...state,
      statistics: null
    })),
    on(userActions.setUserStatistics, (state, action) => ({
      ...state,
      statistics: action.statistics
    })),
  );
  return reducer(state, action);
};

export const userReducer: StoreReducer<UserState> = {
  name: 'user',
  reducer: userReducerFunction
};
